import {
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { boxSx, deleteAccount } from "./utils";
import { useSignout } from "../../../../../components/user/BCPAuthReducers";
import ModalLoadingFull from "../../../../../components/modals/ModalLoadingFull";
import { getEnvironmentVariable } from "../../../../../global/environmentVariables";

const IS_GW =
  getEnvironmentVariable("IS_GW") === "true" ||
  getEnvironmentVariable("COMPANY_FLAG") === "gw";

const DeleteAccount = ({ navigate, userId }) => {
  const signoutReducer = useSignout();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const onPasswordChange = (e) => {
    const {
      target: { value },
    } = e;

    if (!isTouched) setIsTouched(true);
    setPassword(value);
    setIsPasswordError(!value.length);
  };

  const onClose = () => {
    setPassword("");
    setIsTouched(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <Grid item xs={12} sx={{ mt: 8 }}>
        <Divider />
      </Grid>
      <Grid item xs={12} textAlign="right">
        <Button
          variant="outlined"
          color={IS_GW ? "error" : "neutral"}
          onClick={setIsModalOpen.bind(this, true)}
        >
          Delete Account
        </Button>
      </Grid>
      <Modal
        open={isModalOpen}
        onClose={onClose}
        aria-labelledby="delete-account-title"
        aria-describedby="delete-account-description"
        BackdropProps={{ timeout: 500 }}
      >
        <Box sx={boxSx}>
          <Typography
            id="delete-account-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            What happens if I permanently delete my account?
          </Typography>

          <Typography paragraph>
            You will no longer be able to login with this email/username.
          </Typography>

          <Typography paragraph>
            Some event information, such as, but not limited to, pairings and
            placings information, may still be visible after you delete your
            account. The personal identifying information will be removed (eg.
            first name, last name and email will be removed).
          </Typography>
          <Typography paragraph color="error" variant="h6" component="h2">
            THIS PROCESS CANNOT BE REVERSED!
          </Typography>
          <Typography id="delete-account-description">
            If you wish to continue, please type your password to confirm this
            decision.
          </Typography>
          <Grid container spacing={1} sx={{ marginTop: "1rem" }}>
            <Grid item xs={12}>
              <TextField
                error={isTouched && isPasswordError}
                helperText={isTouched && "Required"}
                name="password"
                value={password}
                type="password"
                label="Your Password"
                variant="outlined"
                inputProps={{ maxLength: 255 }}
                required
                fullWidth
                onBlur={onPasswordChange}
                onChange={onPasswordChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                onClick={onClose}
                fullWidth
                color="info"
                variant="outlined"
                disabled={isProcessing}
              >
                Cancel
              </Button>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Button
                onClick={deleteAccount.bind(
                  this,
                  setIsProcessing,
                  setIsModalOpen,
                  password,
                  signoutReducer,
                  navigate,
                  userId
                )}
                fullWidth
                color="error"
                variant="contained"
                disabled={isProcessing || isPasswordError || password === ""}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {isProcessing && <ModalLoadingFull />}
    </>
  );
};

export default DeleteAccount;
